// hooks/useFetchMyResponses.ts
import { useCallback, useEffect, useState } from 'react';
import { getAPI } from '../../services/api.service';
import { toast } from 'react-toastify';

export type Phase = 'all' | 'pre' | 'during' | 'post';

export const useFetchResponsesForParticipant = (initial?: { page?: number; limit?: number }) => {
    const user = JSON.parse(localStorage.getItem('user') || '{}') as { id?: string; role?: string };
    const userId = user?.id;

    const [page, setPage] = useState<number>(initial?.page ?? 1);
    const [limit, setLimit] = useState<number>(initial?.limit ?? 10);
    const [phase, setPhase] = useState<Phase>('all');
    const [groupId, setGroupId] = useState<string | null>(null);
    const [search, setSearch] = useState<string>('');

    const [reviews, setReviews] = useState<any[]>([]);
    const [total, setTotal] = useState<number>(0);
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<string | null>(null);

    const fetchPage = useCallback(async (p = page, l = limit) => {
        if (!userId) {
            setError('User not logged in');
            return;
        }
        setLoading(true);
        setError(null);
        try {
            const params: any = {
                userId,
                page: p,
                limit: l,
                phase
            };
            if (groupId) params.groupId = groupId;
            if (search && search.trim()) params.search = search.trim();

            const res = await getAPI<{ data: any, total: number }>('/book-review/review-response/participant/phase-wise-responses', params);
            const payload = res?.data ?? res;
            const results = payload?.data?.reviews ?? [];
            const tot = payload?.data?.total ?? 0;
            setReviews(Array.isArray(results) ? results : []);
            setTotal(Number(tot || 0));
        } catch (err: any) {
            console.error('fetch my responses error', err);
            setError(err?.response?.data?.message || err?.message || 'Failed to fetch');
            toast.error(err?.response?.data?.message || 'Failed to fetch responses');
        } finally {
            setLoading(false);
        }
    }, [userId, page, limit, phase, groupId, search]);

    useEffect(() => {
        setPage(1);
        fetchPage(1, limit);
    }, [phase, groupId, search, fetchPage, limit]);

    useEffect(() => {
        fetchPage(page, limit);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [page, limit]);

    return {
        reviews,
        total,
        loading,
        error,
        page,
        limit,
        setPage,
        setLimit,
        phase,
        setPhase,
        groupId,
        setGroupId,
        search,
        setSearch,
        reload: () => fetchPage(page, limit)
    };
};
